export default __webpack_public_path__ + "static/media/ex-about-us.6209ba45.jpg";